class InstructionsPanel extends Phaser.Sprite {
  constructor({ id, game, sheet, index, hasRays }) {
    super(game);
    this.sheet = sheet;
    this.loadTexture(this.sheet, id);
  }

  init({ position }) {
    this.position.set(position.x, position.y);
    this.alpha = 0;
  }

  show() {
    this.scale.set(0.5);
    this.game.add.tween(this.scale).to({ x: 1, y: 1 }, InstructionsPanel.ANIM_DURATION, 'Cubic.easeOut', true);
    this.game.add.tween(this).to({ alpha: 1 }, InstructionsPanel.ANIM_DURATION * 0.75, 'Cubic.easeIn', true);
  }

  destroy() {
    super.destroy(true);
  }
}
InstructionsPanel.ANIM_DURATION = 500;
export default InstructionsPanel;
